exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "i {\r\n\twidth: 24px !important;\r\n\theight: 24px !important;\r\n\tfont-size: 24px !important;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/vwa/components/Icon/icon.css
// module id = 688
// module chunks = 0